import id from './{id}';
import query from './query';
import get from './get';
import post from './post';

export type PostPayload = {
  active: boolean;
  alwaysReact?: boolean;
  channelName: string;
  condition: string;
  cronTime?: number;
  debounceTime?: number;
  description?: number;
  iconId: number;
  name: number;
  nodeTypeId: number;
};
export default { id, query, get, post };
